import styled from 'styled-components'
import { Typography } from '@/ui/components'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.background};
`

export default function AppFallback() {
  return (
    <Container>
      <Typography variant="Body/Body-16-medium" color="textSecondary">
        画面を読み込んでいます...
      </Typography>
    </Container>
  )
}
